import {
  cilBasket,
  cilBlur,
  cilBoatAlt,
  cilBriefcase,
  cilBuilding,
  cilCalendarCheck,
  cilCart,
  cilChart,
  cilDrop,
  cilFeaturedPlaylist,
  cilGroup,
  cilInfo,
  cilLocationPin,
  cilMediaSkipBackward,
  cilMemory,
  cilMoney,
  cilSave,
  cilSettings,
  cilShieldAlt,
  cilSpeedometer,
  cilTask,
  cilTruck,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CNavGroup, CNavItem } from '@coreui/react-pro'
import React from 'react'
import { JIRA_SUPPORT_URL, RED_CLIP_FORM, RED_CLIP_MANAGEMENT } from './constants/Constants'
import {
  INTERNAL_SUPPORT_RED_CLIP_FORM,
  INTERNAL_SUPPORT_RED_CLIP_MANAGEMENT,
  MENU_ADMIN,
  MENU_APPOINTMENT,
  MENU_BARCODE_GENERATOR,
  MENU_BILLING,
  MENU_BILLING_CLIENT_PRICING,
  MENU_BILLING_INVOICES,
  MENU_CARRIER,
  MENU_CLIENT,
  MENU_CLIENTS,
  MENU_COUNTRY,
  MENU_DASHBOARD,
  MENU_DEPARTMENTS,
  MENU_ERRORS,
  MENU_HOLIDAY,
  MENU_INTERNAL_SUPPORT,
  MENU_INVENTORY,
  MENU_ITEM,
  MENU_JOBS,
  MENU_LANGUAGES,
  MENU_LOCATION,
  MENU_OPERATIONAL_FUNCTIONS,
  MENU_ORDERS,
  MENU_ORDER_ACTIVITY,
  MENU_PACKING,
  MENU_PERMISSIONS,
  MENU_PLATFORMS,
  MENU_PRODUCTS,
  MENU_PROVINCE,
  MENU_PURCHASE_ORDER,
  MENU_RECEIVING,
  MENU_RECEIVING_MOBILE,
  MENU_RECEIVING_TRANSACTIONS,
  MENU_RETURN,
  MENU_ROLES,
  MENU_SECURITY,
  MENU_SERIAL_NUMBER,
  MENU_SETTINGS,
  MENU_SHIPPING,
  MENU_SUPPLIER,
  MENU_SUPPLY,
  MENU_SUPPORT,
  MENU_SYSTEM,
  MENU_TAXES,
  MENU_TAX_CLASSES,
  MENU_TAX_RATES,
  MENU_TODO,
  MENU_TRANSACTIONS,
  MENU_USER,
  MENU_WAREHOUSE,
  MENU_ZONES,
} from './constants/PermissionConstants'

const _nav = [
  {
    component: CNavItem,
    name: 'dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    permissions: [MENU_DASHBOARD],
  },
  {
    component: CNavGroup,
    name: 'dashboards',
    to: '/dashboards',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    permissions: [MENU_DASHBOARD],
    items: [
      {
        component: CNavItem,
        name: 'dashboard',
        to: '/dashboards/dashboard',
        permissions: [MENU_DASHBOARD],
      },
      {
        component: CNavItem,
        name: 'order-activity',
        to: '/dashboards/order-activity',
        permissions: [MENU_ORDER_ACTIVITY],
      },
    ],
  },
  {
    component: CNavItem,
    name: 'appointment',
    to: '/appointments',
    icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
    permissions: [MENU_APPOINTMENT],
  },
  {
    component: CNavItem,
    name: 'orders',
    to: '/orders',
    icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
    permissions: [MENU_ORDERS],
  },
  {
    component: CNavGroup,
    name: 'products',
    to: '/products',
    icon: <CIcon icon={cilBriefcase} customClassName="nav-icon" />,
    permissions: [MENU_PRODUCTS],
    items: [
      {
        component: CNavItem,
        name: 'inventory',
        to: '/products/inventory',
        permissions: [MENU_INVENTORY],
      },
      {
        component: CNavItem,
        name: 'transactions',
        to: '/products/transactions',
        permissions: [MENU_TRANSACTIONS],
      },
      {
        component: CNavItem,
        name: 'receiving-transactions',
        to: '/products/receiving-transactions',
        permissions: [MENU_RECEIVING_TRANSACTIONS],
      },
      {
        component: CNavItem,
        name: 'item',
        to: '/products/items',
        permissions: [MENU_ITEM],
      },
      {
        component: CNavItem,
        name: 'barcode-generator',
        to: '/products/barcode',
        permissions: [MENU_BARCODE_GENERATOR],
      },
    ],
  },
  {
    component: CNavItem,
    name: 'purchase-order',
    to: '/po',
    icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
    permissions: [MENU_PURCHASE_ORDER],
  },
  {
    component: CNavItem,
    name: 'suppliers',
    to: '/suppliers',
    icon: <CIcon icon={cilBasket} customClassName="nav-icon" />,
    permissions: [MENU_SUPPLIER],
  },
  {
    component: CNavItem,
    name: 'receiving',
    to: '/receiving',
    icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
    permissions: [MENU_RECEIVING],
  },
  {
    component: CNavItem,
    name: 'jobs',
    to: '/jobs',
    icon: <CIcon icon={cilTask} customClassName="nav-icon" />,
    permissions: [MENU_JOBS],
  },
  {
    component: CNavItem,
    name: 'zones',
    to: '/zones',
    icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
    permissions: [MENU_ZONES],
  },
  {
    component: CNavItem,
    name: 'shipping',
    to: '/shipping',
    icon: <CIcon icon={cilBoatAlt} customClassName="nav-icon" />,
    permissions: [MENU_SHIPPING],
  },
  {
    component: CNavItem,
    name: 'returns',
    to: '/returns',
    icon: <CIcon icon={cilMediaSkipBackward} customClassName="nav-icon" />,
    permissions: [MENU_RETURN],
  },
  {
    component: CNavGroup,
    name: 'operational-functions',
    to: '/operational-functions',
    icon: <CIcon icon={cilBlur} customClassName="nav-icon" />,
    permissions: [MENU_OPERATIONAL_FUNCTIONS],
    items: [
      {
        component: CNavItem,
        name: 'packing',
        to: '/packing',
        permissions: [MENU_PACKING],
      },
      {
        component: CNavItem,
        name: 'todo',
        to: '/todo',
        permissions: [MENU_TODO],
      },
      {
        component: CNavItem,
        name: 'receiving-mobile',
        to: '/receiving-mobile',
        permissions: [MENU_RECEIVING_MOBILE],
      },
      {
        component: CNavItem,
        name: 'serial-number',
        to: '/serial-number',
        permissions: [MENU_SERIAL_NUMBER],
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'clients',
    to: '/clients',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    permissions: [MENU_CLIENTS],
    items: [
      {
        component: CNavItem,
        name: 'client',
        to: '/clients/clients',
        permissions: [MENU_CLIENT],
      },
      {
        component: CNavItem,
        name: 'supply',
        to: '/clients/supply',
        permissions: [MENU_SUPPLY],
      },
    ],
  },
  {
    component: CNavItem,
    name: 'warehouse',
    to: '/warehouses',
    icon: <CIcon icon={cilBuilding} customClassName="nav-icon" />,
    permissions: [MENU_WAREHOUSE],
  },
  {
    component: CNavItem,
    name: 'location',
    to: '/locations',
    icon: <CIcon icon={cilLocationPin} customClassName="nav-icon" />,
    permissions: [MENU_LOCATION],
  },
  {
    component: CNavGroup,
    name: 'billing',
    to: '/billing',
    icon: <CIcon icon={cilMoney} customClassName="nav-icon" />,
    permissions: [MENU_BILLING],
    items: [
      {
        component: CNavItem,
        name: 'invoices',
        to: '/billing/invoices',
        permissions: [MENU_BILLING_INVOICES],
      },
      {
        component: CNavItem,
        name: 'client-pricing',
        to: '/billing/client-pricing',
        permissions: [MENU_BILLING_CLIENT_PRICING],
      },
      {
        component: CNavGroup,
        name: 'taxes',
        to: '/taxes',
        icon: <CIcon icon={cilFeaturedPlaylist} customClassName="nav-icon" />,
        permissions: [MENU_TAXES],
        items: [
          {
            component: CNavItem,
            name: 'tax-rates',
            to: '/billing/taxes/tax-rates',
            permissions: [MENU_TAX_RATES],
          },
          {
            component: CNavItem,
            name: 'tax-classes',
            to: '/billing/taxes/tax-classes',
            permissions: [MENU_TAX_CLASSES],
          },
        ],
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'admin',
    to: '/admin',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    permissions: [MENU_ADMIN],
    items: [
      {
        component: CNavGroup,
        name: 'security',
        to: '/security',
        icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
        permissions: [MENU_SECURITY],
        items: [
          {
            component: CNavItem,
            name: 'permissions',
            to: '/security/permissions',
            permissions: [MENU_PERMISSIONS],
          },
          {
            component: CNavItem,
            name: 'roles',
            to: '/security/roles',
            permissions: [MENU_ROLES],
          },
          {
            component: CNavItem,
            name: 'user',
            to: '/security/users/users-list',
            permissions: [MENU_USER],
          },
        ],
      },
      {
        component: CNavGroup,
        name: 'system',
        to: '/system',
        icon: <CIcon icon={cilSave} customClassName="nav-icon" />,
        permissions: [MENU_SYSTEM],
        items: [
          {
            component: CNavItem,
            name: 'countries',
            to: '/system/countries',
            permissions: [MENU_COUNTRY],
          },
          {
            component: CNavItem,
            name: 'province',
            to: '/system/provinces',
            permissions: [MENU_PROVINCE],
          },
          {
            component: CNavItem,
            name: 'languages',
            to: '/system/languages/languages',
            permissions: [MENU_LANGUAGES],
          },
          {
            component: CNavItem,
            name: 'holiday',
            to: '/system/holidays',
            permissions: [MENU_HOLIDAY],
          },
          {
            component: CNavItem,
            name: 'departments',
            to: '/system/departments/departments',
            permissions: [MENU_DEPARTMENTS],
          },
          {
            component: CNavItem,
            name: 'platforms',
            to: '/system/platforms/platforms',
            permissions: [MENU_PLATFORMS],
          },
          {
            component: CNavItem,
            name: 'carrier',
            to: '/system/carriers/carriers',
            permissions: [MENU_CARRIER],
          },
          {
            component: CNavItem,
            name: 'errors',
            to: '/system/errors',
            permissions: [MENU_ERRORS],
          },
          {
            component: CNavItem,
            name: 'settings',
            to: '/system/settings/settings',
            permissions: [MENU_SETTINGS],
          },
        ],
      },
    ],
  },
  // TODO: Disable logs for now, requires backend implementation
  // {
  //   component: CNavGroup,
  //   name: 'logs',
  //   to: '/logs',
  //   icon: <CIcon icon={cilList} customClassName="nav-icon" />,
  //   permissions: [MENU_LOGS],
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'order-logs',
  //       to: '/logs/order-logs',
  //       permissions: [MENU_LOGS],
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'schedule-logs',
  //       to: '/logs/schedule-logs',
  //       permissions: [MENU_LOGS],
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'schedule-item-logs',
  //       to: '/logs/schedule-item-logs',
  //       permissions: [MENU_LOGS],
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'queue-logs',
  //       to: '/logs/queue-logs',
  //       permissions: [MENU_LOGS],
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'failed-job-logs',
  //       to: '/logs/failed-job-logs',
  //       permissions: [MENU_LOGS],
  //     },
  //   ],
  // },
  {
    component: CNavGroup,
    name: 'internal-support',
    to: '/internal-support',
    icon: <CIcon icon={cilInfo} customClassName="nav-icon" />,
    permissions: [MENU_INTERNAL_SUPPORT],
    items: [
      // {
      //   component: CNavItem,
      //   name: 'tech-support',
      //   to: JIRA_TECH_SUPPORT_URL,
      //   target: '_blank',
      //   permissions: [MENU_INTERNAL_SUPPORT],
      // },
      {
        component: CNavItem,
        name: 'red-clip-form',
        to: RED_CLIP_FORM,
        target: '_blank',
        permissions: [INTERNAL_SUPPORT_RED_CLIP_FORM],
      },
      {
        component: CNavItem,
        name: 'red-clip-management',
        to: RED_CLIP_MANAGEMENT,
        target: '_blank',
        permissions: [INTERNAL_SUPPORT_RED_CLIP_MANAGEMENT],
      },
    ],
  },
  {
    component: CNavItem,
    name: 'support',
    to: JIRA_SUPPORT_URL,
    target: '_blank',
    icon: <CIcon icon={cilMemory} customClassName="nav-icon" />,
    permissions: [MENU_SUPPORT],
  },
]

export default _nav
